
function unique(newarr) {
  const res = new Map();
  return newarr.filter((arr) => !res.has(arr.merchantId) && res.set(arr.merchantId, 1));
}
let actis = []
const coupon = {
  state: {
    // 供应商信息
    merchantLines: [],
    merchantLinesActi: [],
    couponItems: []
  },
  actions: {},
  mutations: {
    UPDATE_MERCHANT_COUPON(state, data) {
      state.merchantLines = data
    },
    ADD_MERCHANT_COUPON(state, data) {
      unique(state.merchantLines.push(data))
    },
    REMOVE_MERCHANT_COUPON(state, data) {
      state.merchantLines = data
    },
    DELETE_MERCHANGT_COUPON(state, index) {
      state.merchantLines.splice(index, 1)
    },

    UPDATE_MERCHANT_ACTI(state, data) {
      state.merchantLinesActi = data
    },
    ADD_MERCHANT_ACTI(state, data) {
      actis.push(data)
      state.merchantLinesActi = unique(actis)
    },
    REMOVE_MERCHANT_ACTI(state, data) {
      state.merchantLinesActi = data
    },
    DELETE_MERCHANGT_ACTI(state, index) {
      state.merchantLinesActi.splice(index, 1)
    },

    // 选择优惠券状态存储
    UPDATE_SELECT_COUPON(state, data) {
      state.couponItems = data
    },
    ADD_SELECT_COUPON(state, data) {
     // unique(state.couponItems.push(data))
      state.couponItems = data
      console.log(state.couponItems)
    },
    REMOVE_SELECT_COUPON(state, data) {
      state.couponItems = data
    },
    DELETE_SELECT_COUPON(state, index) {
      state.couponItems.splice(index, 1)
    },
  }
}

export default coupon
